import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ModalVideo from 'react-modal-video';
import Img from 'gatsby-image';
import BackgroundImage from 'gatsby-background-image';
import TextLoop from 'react-text-loop';
import classNames from 'classnames';
import * as stylesDefault from './defaultTopper.module.scss';
import * as stylesHome from './homeTopper.module.scss';

const HomeTopper = ({
  bgImage,
  className,
  title,
  titleColor,
  textBlock,
  bottomMargin,
  videoPlaceholder,
  vimeoID
}) => {
  const [isOpen, setOpen] = useState(false);
  const [windowExists, setWindowExists] = useState(false);
  useEffect(() => {
    if (window !== 'undefined') {
      setWindowExists(!windowExists);
    }
  }, []);
  return (
    <section
      className={classNames(stylesHome.section, className, { [stylesDefault.bottomMargin]: bottomMargin })}
    >
      <div style={{ backgroundImage: `url(${bgImage.fluid.src})`, backgroundSize: 'cover' }}>
        <Container className={stylesHome.inner}>
          <Row>
            <Col xs={12} lg={12}>
              {title
                && (
                  <h1
                    className={
                      classNames(
                        stylesDefault.title,
                        stylesDefault[`title${titleColor}`],
                        stylesHome.title
                      )
                    }
                  >
                    We make&nbsp;
                    <TextLoop interval={2000}>
                      <span>businesses</span>
                      <span>technology</span>
                      <span>UX</span>
                      <span>performance</span>
                      <span>creative</span>
                      <span>experiences</span>
                      <span>brand strategy</span>
                    </TextLoop>
                    <br />remarkable.
                  </h1>
                )}
            </Col>
          </Row>
          <Row className={stylesHome.homeMargin}>
            <Col xs={{ span: 12, order: 2 }} lg={{ span: 6, order: 1 }}>
              {textBlock
                && (
                  <div className={stylesHome.content} dangerouslySetInnerHTML={{ __html: textBlock.html }} />
                )}
            </Col>
            <Col xs={{ span: 12, order: 1 }} lg={{ span: 6, order: 2 }} className={stylesHome.homeMarginVideo}>
              <div className={stylesHome.videoPlaceholder}>
                <button
                  type="button"
                  className={stylesHome.videoPlaceholderLink}
                  onClick={() => setOpen(true)}
                >
                  <img
                    src={videoPlaceholder.fluid.src}
                    alt={videoPlaceholder.alt}
                    style={{ width: '100%' }}
                  />
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {windowExists
        && (
          <ModalVideo channel="vimeo" autoplay isOpen={isOpen} videoId={vimeoID.text} onClose={() => setOpen(false)} />
        )}
    </section>
  );
};

export default HomeTopper;
